import { combineReducers } from 'redux';
import usuario from './usuario';

export default combineReducers({
    usuario
});